import { EventEmitter } from '@angular/core';
import { CommonService } from '../common.service';
var AppGdprComponent = (function () {
    function AppGdprComponent(commonService) {
        this.commonService = commonService;
        this.closeGDPR = new EventEmitter();
        this.assetsRoute = "../../assets";
        this.buttonTheme = {
            'position': 'inherit',
            'fontSize': 'fontSize15',
            'buttonElem': [
                {
                    'color': 'blue',
                    'text': '个人信息处理请求表',
                    'className': 'inlineBlockRadiusBtn width-70 margin-auto'
                }
            ]
        }; //按钮主题
    }
    AppGdprComponent.prototype.ngOnInit = function () {
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    };
    AppGdprComponent.prototype.close = function () {
        this.closeGDPR.emit();
    };
    AppGdprComponent.prototype.submit = function () {
        window.open('https://ddi.jinshuju.com/f/fMkeNV');
    };
    return AppGdprComponent;
}());
export { AppGdprComponent };



// WEBPACK FOOTER //
// ./src/app/app-gdpr/app-gdpr.component.ts.pre-build-optimizer.js